import React, { useState } from 'react'
import { useFirestoreConnect, isLoaded, isEmpty } from 'react-redux-firebase'
import { useSelector, useDispatch } from 'react-redux'

import { setAdvice, getSpecificUser } from '../../store/actions/apiActions'
import AnimationLayout from '../../components/AnimationLayout'
import MatildeBalloon from '../../components/MatildeBalloon'
import Button from '../../components/Button'
import Loading from '../../components/Loading'

import moment from 'moment'
import 'moment/locale/pt'
import { Link } from 'react-router-dom'
import { EmojiButton } from '../../components/ReactionIcons'
moment.locale('pt')

const Advices = () => {
    const [state, setState] = useState({
        advice: null,
    })

    const dispatch = useDispatch()
    const advicesDocs = useSelector(state => state.firestore.ordered.advices)
    const getReactionItems = useSelector(state => state.firebase.profile.reactionItems)
    const updatingReaction = useSelector(state => state.apiCalls.updatingReactions)
    useFirestoreConnect(() => [{ collection: 'advices', orderBy: ['date', 'desc'], limit: 10 }])
    const { advice } = state

    const handleChange = (event) => {
        setState({
            ...state,
            [event.target.name]: event.target.value
        })
    }

    return (
        <AnimationLayout>
            <MatildeBalloon>
                <p className='text-left'>Nesta página poderá ver os conselhos de outros viajantes do Adventour para aprender novas curiosidades ou estratégias acerca do jogo ou até da vida real!</p>
            </MatildeBalloon>

            <h2>Conselhos</h2>
            <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">
                    <span>Escreva o seu conselho</span>
                    <textarea
                        rows="4"
                        cols="20"
                        name="advice"
                        onChange={handleChange}
                        placeholder="Escreva aqui o contéudo do seu conselho"
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 my-3"
                    />
                </label>
                <div className='flex justify-end'>
                    <Button onClick={() => dispatch(setAdvice(advice))} className='mr-0'>Submeter</Button>
                </div>
            </div>

            {!isLoaded(advicesDocs) ? <Loading /> :
                isEmpty(advicesDocs) ?
                    <p className='pt-4 pb-8'>Ainda não foram submetidos qualquer tipo de conselhos! Sê o primeiro a partilhar um conselho!</p> :
                    <div className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 lg:gap-12 pt-4 pb-8">
                        {updatingReaction ? <Loading /> :
                            advicesDocs && advicesDocs.map((item, index) => {
                                let didUserReact = getReactionItems.find(reaction => reaction.id === item.id && reaction.type === 'advices')
                                let reactionsArray = Object.keys(item.reactions).map((key) => [key, item.reactions[key]])
                                let reactionsArraySorted = reactionsArray.sort((a, b) => a > b)

                                console.log(didUserReact)

                                return (
                                    <div key={index}>
                                        <li className='grid grid-cols-12 gap-6 lg:gap-8 py-2'>
                                            <Link
                                                className='col-span-3 lg:col-span-2 flex justify-center items-center'
                                                to={`perfil/utilizadores/${item?.user}`}
                                                onClick={() => dispatch(getSpecificUser(item.user))}
                                            >
                                                <img
                                                    alt={item?.user}
                                                    className='avatar-rounded mr-6'
                                                    src={require(`../../assets/img/matilde-faces/${item?.avatar}.png`)}
                                                />
                                            </Link>
                                            <div className='col-span-9 lg:col-span-6'>
                                                <h5>{item?.user} - {moment(item?.date).fromNow()}</h5>
                                                <p>{item?.advice}</p>
                                            </div>
                                            <div className='col-span-12 lg:col-span-4 grid grid-cols-4 w-full md:w-auto pt-3 sm:pt-0 gap-4 justify-center items-center'>
                                                {reactionsArraySorted.map((reactionItem, index) => {
                                                    let activeEmoji = null

                                                    if (didUserReact) {
                                                        activeEmoji = didUserReact?.reaction === reactionItem[0] ? true : null
                                                    }
                                                    return (
                                                        <EmojiButton
                                                            key={index}
                                                            item={item}
                                                            type='advices'
                                                            isActive={activeEmoji}
                                                            activeItem={didUserReact}
                                                            symbol={reactionItem[0]}
                                                            label={reactionItem[0]}
                                                            number={reactionItem[1]}
                                                        />
                                                    )
                                                }

                                                )}
                                            </div>
                                        </li>
                                        <hr className='my-4 h-1 bg-gray-400' />
                                    </div>
                                )
                            })}
                    </div>
            }
        </AnimationLayout>
    )
}

export default Advices
